// Single source of truth for frontend version.
// Bump FE_VERSION and FE_BUILD_DATE before every `npm run build`.
export const FE_VERSION = "v2.6.0";
export const FE_BUILD_DATE = "2026-10-10T00:00:00";
